import _ from 'lodash'
import {DateTime} from 'luxon'
const zone = 'America/New_York'

export const now = () => {
  return DateTime.fromObject({zone}).toJSDate()
}

export const isDaysOld = (date, days) => {
  const dateTime = DateTime.fromJSDate(date, {zone})
  const now = DateTime.fromObject({zone})
  return now.diff(dateTime, 'days').days >= days
}

export const coerceToISODate = (input) => {
  if (_.isDate(input)) {
    input = toISOString(input)
    return fromISOString(input)
  }
  if (_.isString(input)) {
    return fromISOString(input)
  }
  throw new Error(`Unknown date format: ${input}`)
}

export const dateTimeFromIsoString = (string) => {
  return DateTime.fromISO(string, {zone})
}

export const fromISOString = (string) => {
  return DateTime.fromISO(string, {zone}).toJSDate()
}

export const toISOString = (date) => {
  return DateTime.fromJSDate(date, {zone}).toISO()
}

export const toLocaleString = (date, format = DateTime.DATETIME_SHORT_WITH_SECONDS) => {
  return DateTime.fromJSDate(date).toLocaleString(format)
}

export const toLocaleDateString = (date) => {
  return DateTime.fromJSDate(date).toLocaleString()
}
